// i18n area 'cluster' — locale no-NO (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.no-NO.meta.json.
import type { enUS } from './cluster'

export const noNO: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Garantitilganger',
      subtitle: 'Nodens servicedør: skrivebeskyttet tilgang med midlertidig passord og nødkontoen med passordet fra safen',
      readOnlyTitle: 'Skrivebeskyttet tilgang (trantor)',
      stateNone: 'lukket',
      stateGranted: 'åpen',
      stateGrantedPending: 'gitt — tas i bruk på noden',
      grantedBy: 'Gitt av',
      grantedAt: 'Gitt den',
      expiresAt: 'Utløper den',
      reason: 'Årsak',
      endedAt: 'Lukket',
      endedReason: {
        revoked: 'tilbakekalt',
        expired: 'utløpt (TTL)',
        reboot: 'omstart av noden',
        failed: 'ikke tatt i bruk (oppgave mislyktes)'
      },
      grant: 'Gi skrivebeskyttet tilgang…',
      grantTitle: 'Gi skrivebeskyttet tilgang',
      grantSubmit: 'Gi',
      grantError: 'Tildelingen ble avvist',
      grantConfirm: 'TVirt genererer et midlertidig passord for systembrukeren «trantor» (kun lesing: journal og diagnostikk, ingen sudo) og setter det på noden med en oppgave. Passordet vises ÉN gang, ved bekreftelsen; det opphører ved utløp, ved tilbakekalling eller ved nodens neste omstart.',
      reasonLabel: 'Årsak',
      reasonHint: 'Hvorfor du åpner døren: det står i tildelingen, i revisjonen og i journalen',
      ttlLabel: 'Varighet',
      ttlHours: '{n} t',
      revoke: 'Tilbakekall skrivebeskyttet tilgang…',
      revokeTitle: 'Tilbakekall skrivebeskyttet tilgang',
      revokeSubmit: 'Tilbakekall',
      revokeError: 'Tilbakekallingen ble avvist',
      revokeConfirm: 'Tildelingen opphører nå, og en oppgave låser brukeren «trantor» på noden igjen: det midlertidige passordet slutter å virke.',
      passwordTitle: 'Skrivebeskyttet passord',
      passwordOnce: 'Dette passordet vises ÉN gang: kopier det nå. Det lagres ingen steder og kan ikke leses igjen — mister du det, gi tilgang på nytt.',
      passwordUser: 'Bruker',
      passwordLabel: 'Passord',
      passwordHint: 'Gyldig til {until}, eller til nodens neste omstart; kan brukes når tildelingsoppgaven er fullført. Tilgang: ssh trantor@<nodens adresse>.',
      emergencyTitle: 'Siste nødtilgang (trantor-emergency)',
      lastLogin: '{time} via {via} fra {from}',
      lastLoginNone: 'ingen observert',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konsoll',
        sudo: 'sudo',
        unknown: 'ukjent'
      },
      emergencyHint: 'Nødkontoen «trantor-emergency» (full sudo) er alltid aktivert med passordet som ble generert ved installasjonen av noden og oppbevares i safen: TVirt kjenner det ikke, roterer det ikke og gjenoppretter det ikke. Hver innlogging rapporteres her og i hendelsesjournalen.'
    },
    nodeFirewall: {
      tab: 'Brannmur',
      title: 'Brannmur for nodene',
      subtitle: 'Holdningen til nftables-rulesettet som hver node tar i bruk på seg selv — den eneste brannmuren på en node (firewalld er deaktivert)',
      modeLabel: 'Holdning',
      mode: {
        disabled: 'Deaktivert — ingen ruleset på nodene',
        permissive: 'Permissiv — teller og logger, forkaster ingenting',
        enforced: 'Håndhevet — bare det avledede registeret slipper inn'
      },
      hint: {
        disabled: 'Som i dag: nodene bærer ingen ruleset. Bytt til permissiv for å LESE hva som ville blitt forkastet før det forkastes.',
        permissive: 'Hver node tar i bruk sitt avledede ruleset med policy accept: det den håndhevede holdningen ville forkastet, telles og logges (journal-prefiks «tvirt-node would-drop:»). Ingenting blokkeres.',
        enforced: 'Hver node tar i bruk sitt avledede ruleset med policy drop: ssh og API fra hvor som helst, store / live migration / overlay / Ceph bare fra medlemmene, lytterne til nettverkstjenestene fra nettet de betjener. Hvert bytte er en apply med bekreftelse — en node som ikke klarer å bekrefte, ruller tilbake av seg selv.'
      },
      confirmTitle: 'Håndheve brannmuren for nodene?',
      confirmBody: 'Hver node tar i bruk rulesettet med bekreftelse: den sonderer backend, store og ssh gjennom de nye reglene innen fristen og bekrefter — ellers går den tilbake til forrige ruleset av seg selv. Les tellerne fra permissiv holdning på nodene først.',
      confirmSubmit: 'Håndhev',
      confirmCancel: 'Avbryt',
      lensTitle: 'Brannmur for noden',
      loadError: 'Kunne ikke laste brannmurlinsen for noden',
      noReport: 'Ingen brannmurrapport fra denne noden ennå — workeren rapporterer ved neste pass',
      firewalldActive: 'firewalld kjører på denne noden: node-brannmuren nekter å bli tatt i bruk ved siden av den (masker firewalld)',
      conditionUnconfirmed: 'Ingen bekreftet ruleset ennå — noden er åpen',
      conditionRolledBack: 'Siste apply rullet tilbake — samme generasjon prøves ikke på nytt før registeret endres eller holdningen byttes igjen',
      lastError: 'Siste feil',
      posture: 'Holdning',
      observedAt: 'Observert',
      desiredGeneration: 'Ønsket generasjon',
      componentTitle: 'Nodekomponent',
      componentSubtitle: 'tvirt-node-firewall — tar i bruk det bekreftede rulesettet ved oppstart, ruller et ubekreftet tilbake av seg selv',
      componentAbsent: 'Komponenten har ikke rapportert ennå',
      phase: 'Fase',
      phases: {
        none: 'Aldri tatt i bruk',
        applied: 'Tatt i bruk — venter på bekreftelse',
        confirmed: 'Bekreftet',
        rolledBack: 'Rullet tilbake'
      },
      generation: 'Generasjon',
      appliedAt: 'Tatt i bruk',
      confirmedAt: 'Bekreftet',
      deadline: 'Rollback-frist',
      lastRollback: 'Siste rollback',
      registryTitle: 'Avledet register',
      registrySubtitle: 'Portene denne noden åpner, etter klasse og opphav — avledet fra clusteret, aldri redigert for hånd',
      registryEmpty: 'Ingenting avledet — holdning deaktivert uten bekreftet ruleset, eller ingen rapport ennå',
      colClass: 'Klasse',
      colPort: 'Port',
      colSource: 'Kilde',
      colOrigin: 'Opphav',
      classes: {
        public: 'Offentlig',
        internode: 'Mellom noder',
        tenant: 'Tenant'
      },
      sourceMembers: 'bare medlemmene',
      sourceAnywhere: 'hvor som helst',
      sourceBridge: 'på {iface}'
    },
    derivationDerived: 'avledet',
    derivationDiverged: 'avveket',
    derivationDerivedTip: 'Nettverksdokumentet er AVLEDET fra fabric {fabric} og stemmer fortsatt med renderen på gjeldende inndata — klikk for derivasjonsplanen.',
    derivationDivergedTip: 'Derivasjonen fra fabric {fabric} endret seg etter siste apply (fabric, kabling, roller eller referanser) — klikk for den ventende diffen.',
    derivationRetiring: {
      one: '{n} adresse dreneres',
      other: '{n} adresser dreneres'
    },
    standaloneHint: 'Denne noden har ikke noe kluster: den er ikke installert ennå. Kluster opprettes ELLER joines ved installasjonen — tokenet generert fra Server-tabellen til et medlem mates til installeren (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Tillatelsene dine dekker et scope, ikke hele clusteret: flåteinventaret — noder, innstillinger og enheter — er bare synlig for cluster-administratorer.',
    phaseReady: 'Klar',
    phaseForming: 'Under dannelse',
    storeMembers: 'Store-medlemmer',
    watermark: 'Konvergensterskel',
    configGeneration: 'Config-generasjon',
    converged: 'på linje',
    behind: 'bak — {m} / {n}',
    revision: 'Revisjon',
    rolesTitle: 'Nettverksroller',
    rolesSubtitle: 'Adresser per medlem for hver trafikklasse — tilkoblingen lever i host-nettverket',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'arver management',
    settingsTitle: 'Innstillinger',
    settingsSubtitle: 'Sikkerhetspolicy på klusternivå — evaluert av hver node fra sin egen lokale replika',
    taskRetentionTitle: 'Task-retensjon',
    taskRetentionSubtitle: 'Enhetlig GC for alle tasks — avsluttede tasks over alderen eller taket samles inn, aldri de som pågår',
    taskRetentionMaxAge: 'Maksimal alder (dager)',
    taskRetentionMaxCount: 'Maksimalt antall tasks',
    eventRetentionTitle: 'Hendelsesoppbevaring',
    eventRetentionSubtitle: 'Journalens GC — en politikk uavhengig av oppgavenes: oppgaven er en kø, hendelsen er minne',
    eventRetentionMaxAge: 'Maksimal alder (dager)',
    eventRetentionMaxCount: 'Maksimalt lagrede hendelser',
    spaceThresholdsTitle: 'Plassterskler',
    spaceThresholdsSubtitle: 'Når en lagring som fylles når journalen (og varslene)',
    spaceLowPct: 'Advarsel fra (% brukt)',
    spaceCriticalPct: 'Kritisk fra (% brukt)',
    spaceOrderError: 'Kritisk kan ikke ligge under advarselen',
    spaceThresholdsHint: 'Bare inngangene konfigureres: utgangen utledes av motoren, 5 poeng under hver terskel, slik at en lagring på linjen aldri blir en metronom',
    failoverReserveTitle: 'Failover-reserve',
    failoverReserveSubtitle: 'N+1 admission control — RAM holdt ledig så klusteret kan starte lasten sin på nytt etter tap av noder',
    failoverReserveTolerate: 'Noder hvis tap skal tolereres',
    failoverReserveOff: '0 — reserven er av: ingen start avvises noen gang av hensyn til failover-kapasitet',
    failoverReserveOn: 'En start som ville tært på reserven avvises med en 412 som forklarer tallene',
    networkShapingTitle: 'Båndbredderettferdighet',
    networkShapingSubtitle: 'De tre typologivektene i shaping-treet per uplink — de virker bare under konkurranse',
    networkShapingRest: 'Vekt for resten (kontrollplan, storage, replikaer)',
    networkShapingOverlay: 'Vekt for overlay-nettverk',
    networkShapingLiveMigration: 'Vekt for live migration',
    networkShapingHint: 'Garantert andel = vekt / sum av de tre (standard 300 / 100 / 200, hver fra 1 til 10000); på en ledig lenke kan hver klasse ta hele båndbredden',
    debugModeTitle: 'Debugmodus',
    debugModeSubtitle:
      'Detaljerte feil i de generiske GUI-varslene — for å se den virkelige årsaken når en handling som «mislyktes» egentlig lyktes',
    debugModeLabel: 'Debugmodus aktivert',
    debugModeOn: 'Generiske feilvarsler legger til den underliggende årsaken — interne detaljer synlige for enhver operatør',
    debugModeOffHint: 'Av — generiske feilvarsler forblir generiske, uten interne detaljer',
    nodeDetailsAction: 'Nodedetaljer',
    node: {
      docTitle: 'Node',
      notFound: 'Fant ikke noden',
      tabOverview: 'Oversikt',
      tabStats: 'Statistikk',
      tabNetwork: 'Nettverk',
      tabSettings: 'Lokale innstillinger',
      identityTitle: 'Identitet',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL-port',
      revision: 'Config-revisjon',
      versionsTitle: 'Observerte versjoner',
      heartbeatSubtitle: 'Den siste tilstanden noden har rapportert om seg selv',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU-modell',
      memoryTitle: 'Minne',
      hugePagesTitle: 'Enorme sider',
      hugePagesPool: '{size}: {free} ledige av {total}',
      hugePagesNone: 'Ingen pulje',
      hugePagesNoneHint: 'Noden har ingen enorme sider reservert: virtuelle maskiner som ber om dem, kan ikke starte her. Puljen erklæres på noden med kjerneparameterne hugepagesz og hugepages eller ved å skrive nr_hugepages.',
      usageTitle: 'Nåværende bruk',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'ikke observert — ingen fersk prøve',
      statsNoData: 'Ingen data i intervallet — nodens serier samples av noden selv og serveres lokalt.',
      observedTitle: 'Observert tilstand',
      observedSubtitle: 'Tjenester og assets lokale for noden, slik workeren ser dem'
    },
    editRolesTitle: 'Rediger nettverksrollene',
    memberNode: 'Node',
    memberIp: 'IP-adresse',
    addMember: 'Legg til medlem',
    lmInherit: 'Bruk management-adressene',
    roleIpHint: 'Å legge til og fjerne medlemmer er fritt; å endre IP-en til et eksisterende medlem på stedet avvises — IP-migreringsflyten kommer i en senere runde.',
    roleError: 'Kunne ikke oppdatere rollene',
    nodesTitle: 'Noder',
    addNodeTitle: 'Legg til node i klusteret',
    addNode: 'Legg til node',
    addNodeError: 'Kunne ikke forhåndsregistrere noden',
    nodeName: 'Nodenavn',
    nodeNameHint: 'må stemme med navnet valgt ved installasjonen',
    nodeIp: 'Management-IP',
    colName: 'Navn',
    colPhase: 'Fase',
    colServices: 'Tjenester',
    colWatermark: 'Watermark',
    colLastSeen: 'Siste kontakt',
    colUps: 'UPS',
    upsCordonChip: 'UPS-sperre',
    upsCordonTip: 'Noden dømte seg selv på sin UPS’ fakta ({time}): den opphever sperren selv når nettet er stabilt og batteriet er ladet',
    upsUnreachable: 'UPS utilgjengelig',
    upsOnBattery: 'På batteri',
    upsOnLine: 'På nett',
    upsLowBattery: 'lavt batteri',
    upsNoEstimateChip: 'gjenværende tid ikke estimert',
    upsNoEstimateTip: 'UPS-en publiserer ingen estimert gjenværende tid: noden dømmes kun av UPS-ens LB-flagg (lavt batteri) — juster battery.runtime.low / LB på selve UPS-en',
    upsLaneTip: 'UPS-nedstengingsbane siden {since}: dømt av {by}',
    upsUnit: 'enhet',
    upsStatus: 'NUT-status',
    upsLoad: 'last',
    upsOnBatterySince: 'på batteri siden',
    upsOnLineSince: 'på nett siden',
    upsError: 'feil',
    upsObservedAt: 'observert',
    upsNone: 'ingen UPS-enhet betjener denne noden',
    upsBy: {
      runtime: 'gjenværende tid under terskelen',
      lowBattery: 'UPS-ens LB-flagg',
    },
    upsLane: {
      evacuate: 'evakuering',
      local: 'nedstenging på stedet',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'stopper gjester',
      stoppingServices: 'stopper tjenester',
      poweredOff: 'slått av',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS-enheter og terskler: noden dømmes ved gjenværende tid ≤ terskel eller LB-flagg (alltid respektert), gjenopptak med hysterese',
    upsRuntimeThreshold: 'Terskel for gjenværende tid (s)',
    upsRuntimeThresholdHint: 'På batteri med estimert gjenværende tid ≤ terskel stenger noden ned i rekkefølge (standard 300)',
    upsResumeStable: 'Nett stabilt i (s)',
    upsResumeStableHint: 'Gjenoppta bare med uavbrutt nett i minst så mange sekunder (standard 60)',
    upsResumeCharge: 'Minste lading ved gjenopptak (%)',
    upsResumeChargeHint: 'Og batteri ladet til minst denne prosenten (standard 25)',
    upsPolicyNote: 'UPS-ens LB-flagg (lavt batteri) dømmer alltid og kan ikke slås av; det finnes ingen terskel for tiden på batteri. Hver enhet kan overstyre de tre tallene.',
    upsUnitNew: 'ny enhet',
    upsUnitSelectors: '{n} tag-velger(e) (kun CLI)',
    upsUnitName: 'Enhetens navn',
    upsUnitMode: 'Modus',
    upsModeExternal: 'ekstern (andres upsd)',
    upsModeManaged: 'administrert (UPS koblet til en node)',
    upsUnitUpsname: 'NUT-navn (upsname)',
    upsUnitHost: 'upsd-vert',
    upsUnitAttachedNode: 'Tilkoblet node',
    upsUnitDriver: 'NUT-driver',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Driverens enhet',
    upsUnitDeviceHint: 'linjen port= i ups.conf: tom = auto',
    upsUnitPort: 'upsd-port',
    upsUnitServedNodes: 'Betjente noder',
    upsUnitServedNodesHint: 'nodenavn adskilt med komma (tag-velgere går via CLI)',
    upsUnitOverrideHint: 'tom = klyngens standard',
    upsUnitAdd: 'Legg til enhet',
    unreachableSince: 'Utilgjengelig — siste heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay-dataplanet har ikke realisert den nåværende overlay-konfigurasjonen ennå',
    overlaysError: 'Siste overlay-rekonsilieringspass feilet: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Venter på join',
      'joining': 'Joiner',
      'member': 'Medlem'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Vises bare nå — kopier det med en gang, det blir aldri lesbart igjen',
    copy: 'Kopier',
    copied: 'Kopiert',
    close: 'Lukk',
    revokeTitle: 'Tilbakekall forhåndsregistrering',
    revoke: 'Tilbakekall',
    revokeError: 'Kunne ikke tilbakekalle registreringen',
    promote: 'Forfrem til store-medlem',
    demote: 'Fjern store-member-rollen',
    troubleshoot: 'Feilsøking',
    promoteTitle: 'Forfrem til store-medlem',
    demoteTitle: 'Fjern store-member-rollen',
    promoteHint: 'Noden går inn i quorumet av YugabyteDB-mastere. Ekte HA krever tre store-medlemmer.',
    demoteHint: 'Noden går ut av master-quorumet og stopper store-tjenestene sine.',
    storeError: 'Endringen av store-medlemmet ble avvist',
    attest: 'Attester avslått…',
    attestTitle: 'Attester noden avslått',
    attestSubmit: 'Attester avslått',
    attestConfirm: 'Du erklærer denne noden avslått, på egen risiko: å attestere en node som egentlig lever risikerer VM-er i dobbel kjøring. Taskene dens feiles og authorityene til VM-ene dens blir overførbare.',
    attestError: 'Attestasjonen ble avvist',
    attestedChip: 'attestert avslått',
    maintenanceChip: 'vedlikehold',
    guestToolsChip: 'TVirt Guest Tools (ISO-asset lokal for noden)',
    maintenanceEnter: 'Aktiver vedlikehold',
    maintenanceExit: 'Deaktiver vedlikehold',
    maintenanceEnterTitle: 'Aktiver vedlikehold',
    maintenanceExitTitle: 'Deaktiver vedlikehold',
    maintenanceEnterSubmit: 'Aktiver vedlikehold',
    maintenanceExitSubmit: 'Deaktiver vedlikehold',
    maintenanceEnterConfirm: 'Noden sperres av og tømmes: nettverkstjenestene og App-instansene den holder authority for, overføres (instansene kaldt: stoppet og høstet her, gjenskapt på målnoden — nedetid), kjørende VM-er live-migreres der det er mulig og stoppes ellers pent, pågående oppgaver fullføres, nytt arbeid holdes tilbake, og stoppede VM-er mister sin authority — Proximity plasserer dem på nytt ved neste start. Ingenting kommer tilbake av seg selv når vedlikeholdet er over.',
    maintenanceExitConfirm: 'Noden gjenopptar arbeidet og Proximity vurderer den igjen for placement. VM-ene kommer tilbake først når de startes.',
    maintenanceError: 'Vedlikeholdsforespørselen ble avvist',
    maintenancePlanTitle: 'Evakueringsplan',
    maintenancePlanLoading: 'Beregner evakueringsplanen…',
    maintenancePlanError: 'Kunne ikke laste evakueringsplanen — drainen migrerer likevel der det er mulig og stopper resten.',
    maintenancePlanEmpty: 'Ingenting å evakuere på denne noden — ingen aktiv nettverkstjeneste, ingen App-instans ønsket kjørende, ingen kjørende VM.',
    maintenancePlanSummary: '{migrate} objekter migrerer (VM-er, nettverkstjenester, App-instanser), {stop} stoppes eller blir der de er.',
    maintenancePlanReserve_ok: 'Failover-reserve etter tømmingen: intakt — det gjenstår {headroom} GiB startbare med toleranse for tap av {n} node(r).',
    maintenancePlanReserve_eroded: 'Failover-reserve etter tømmingen: nesten oppbrukt — bare {headroom} GiB gjenstår av de {reserve} GiB holdt ledige for {n} nodefeil.',
    maintenancePlanReserve_exhausted: 'Failover-reserve etter tømmingen: OPPBRUKT — det mangler {headroom} GiB av de {reserve} GiB som trengs for å tolerere {n} nodefeil. Så lenge denne noden er ute, avvises nye VM-starter.',
    maintenancePlanReserve_unknown: 'Failover-reserve etter tømmingen: ikke beregnbar — ingen gjenværende node har deklarert minnet sitt.',
    maintenancePlanReserveHugePages: 'Enorme sider på {size} etter tømmingen — ledige: {free} av {capacity}, krevd som reserve: {reserve}.',
    maintenancePlanActionMigrate: 'migrerer',
    maintenancePlanActionMigrateWarning: 'migrerer (soft regel brutt)',
    maintenancePlanActionStop: 'stopper',
    maintenancePlanActionBlocked: 'blokkert',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'nettverkstjeneste',
    maintenancePlanKindApp: 'App-instans',
    maintenancePlanColdMove: 'Kald flytting: podden stoppes og høstes her og gjenskapes på målnoden av dens worker — nedetid til målworkerens neste pass.',
    caFingerprint: 'Fingerprint for klusterets CA',
    staleChip: 'ikke oppdatert',
    troubleshootTitle: 'Feilsøking av storen',
    restartStore: 'Start store-tjenestene på nytt',
    restartHint: 'Hvis storen lager krøll, start tjenestene dens på nytt. Avansert — brukes med forsiktighet.',
    restartQueued: 'Omstart-task i kø',
    restartError: 'Kunne ikke starte tjenestene på nytt',
    svcActive: 'aktiv',
    svcWanted: 'ønsket, ikke aktiv',
    svcStopped: 'stoppet',
    noServices: 'Ingen tjeneste rapportert'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Hele klusterets GPU-inventar gruppert etter modell — kortene observert per node, med markerte registreringer og taggene deres',
    usbTitle: 'USB-ressurser',
    usbSubtitle: 'Hele klusterets USB-inventar gruppert etter modell — enhetene observert per node, med registreringer i begge modeller (per enhet, per port) og taggene deres',
    markedChip: '{n} brukbare av TVirt',
    orphanChipGpu: '{n} foreldreløse',
    orphanChipUsb: '{n} foreldreløse',
    colNode: 'Node',
    colRegistration: 'Registrering',
      noRegsHint: 'Ingen registrering — enheten merkes "brukbar av TVirt" fra nodens dialog (Noder › node › Innstillinger).',
      colDevice: 'Enhet',
      colObserved: 'Observerte',
      colRegs: 'Registreringer',
      regsNone: 'ingen',
      colPci: 'PCIe-adresse',
      colIdentity: 'Identitet / port',
      colClasses: 'Klasser (tagger)',
      colActions: 'Handlinger',
      manageOnNode: 'Forvalt på noden {node} (markeringen lever i nodens dialog)',
      introTitle: 'Kluster-inventaret over USB- og PCIe-enheter brukbare av TVirt©.',
      introStep1: '1. Nodene oppdager selv sine GPU-er og USB-enheter (kartlegging i heartbeaten).',
      introStep2: '2. En enhet merkes "brukbar av TVirt" fra NODENS dialog (Noder › node › Innstillinger) — markeringen binder den til vfio og registrerer den her.',
      introStep3: '3. Her gir du registreringene deres KLASSER via tagger (f.eks. gpu_class=compute): VM-kravene ber om en klasse, og scheduleren velger en node med en kompatibel ledig enhet.',
    colMode: 'Modus',
    colState: 'Status',
    colNotes: 'Notater',
    colTags: 'Tagger',
    modeDevice: 'per enhet',
    modePort: 'per port',
    usable: 'brukbar',
    orphanGpu: 'foreldreløs',
    orphanUsb: 'foreldreløs',
    hubChip: 'hub',
    orphanPortsTitle: 'Per-port-registreringer uten tilkoblet enhet — koble til en enhet igjen eller avmerk dem fra noden',
    gpusEmpty: 'Ingen GPU observert på noen node ennå',
    usbEmpty: 'Ingen USB-enhet observert på noen node ennå'
  },
  settings: {
    passwordMinLength: 'Minste passordlengde',
    sessionIdle: 'Timeout for inaktiv sesjon (minutter)',
    lockoutThreshold: 'Låsing etter mislykkede forsøk',
    lockoutDuration: 'Låsingens varighet (minutter)',
    keyboardLayout: 'Tastaturoppsett',
    keyboardLayoutHint: 'f.eks. it, en-us — tomt for QEMU-defaulten',
    syslogEndpoint: 'Syslog-endpoint',
    syslogEndpointHint: 'host:port — tomt for å deaktivere videresendingen',
    syslogTls: 'TLS',
    maxQueued: 'Maks tasks i kø',
    concurrency: 'Workerens samtidighet',
    concurrencyHint: 'Tas i bruk på direkten av workeren',
    notesTitle: 'Notater',
    save: 'Lagre',
    saved: 'Innstillinger lagret',
    saveError: 'Kunne ikke lagre innstillingene'
  },
  localSettings: {
    derivedChip: 'avledet',
    derivedTip: 'Dette devicet EIES av fabric-derivasjonen (H2): editoren nekter å røre det — endre fabricen (eller kablingen) og bruk på nytt, eller ta det tilbake nedenfor.',
    takeOwnership: 'Ta eierskap',
    takeOwnershipTitle: 'Ta eierskap (take-ownership)',
    takeOwnershipConfirm: '{name} forlater fabric-blokken og blir igjen et MANUELT device som denne editoren styrer. Noden blir avveket, og neste derivasjons-apply avslår på den (manualConflict) til du gir det nytt navn eller fjerner det — eller retter fabricen.',
    nodeSettingsTitle: 'Nodeinnstillinger',
    nodeSettingsSubtitle: 'Det denne noden anvender — task-kø, konsoll, logg-videresending — pluss taggene og notatene dens',
    baseTitle: 'Host-reserver (TVirt Proximity)',
    baseSubtitle: 'CPU og RAM reservert til hostens operativsystem — inputene til den empiriske kapasiteten Proximity plasserer VM-ene med',
    baseMemory: 'Base-RAM (MiB)',
    baseMemoryHint: 'Observert totalt: {total} MiB. Brukbart for VM-ene = totalt − base − RAM for de påslåtte VM-ene plassert her.',
    baseMemoryHintNoTotal: 'Brukbart for VM-ene = observert totalt − base − RAM for de påslåtte VM-ene plassert her.',
    baseCpu: 'Base-CPU-kjerner',
    baseCpuHint: 'Observerte logiske CPU-er: {total}. Brukes bare som ranking-vekt — vCPU-overcommit er normalt.',
    baseCpuHintNoTotal: 'Brukes bare som ranking-vekt — vCPU-overcommit er normalt.',
    baseHint: 'RAM er den harde admission-porten: en VM som ikke får plass i den brukbare RAM-en avvises med en talende feil. Hev basen på hoster som huser store-medlemmer eller Ceph-daemoner.',
    placementTitle: 'Fysisk plassering',
    placementSubtitle: 'Hvor denne serveren fysisk står — deklarert én gang, til hva enn det trengs',
    placementHint: 'Plasseringen styrer CRUSH-hierarkiet til hvert Ceph-kluster med en OSD på denne serveren: å lagre en endring realigner kartene deres via task (host → rack → … → root). Delvise deklarasjoner er lovlige — tomme nivåer kollapser. Navnene deles over hele kartet: to servere i samme rack deklarerer samme rack-navn.',
    placementNameInvalid: 'DNS-safe navn (små bokstaver, sifre, bindestreker)',
    placementEmpty: 'Tomt = ikke deklarert',
    placementLevel: {
      chassis: 'Chassis',
      rack: 'Rack',
      row: 'Rad',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Rom',
      datacenter: 'Datasenter',
      zone: 'Sone',
      region: 'Region'
    },
    cablingTitle: 'Kabling',
    cablingSubtitle: 'Hvilken switchport hvert grensesnitt er koblet til — deklarasjonen lever på noden (Annex O.9)',
    cablingHint: 'Én kabel per NIC, én kabel per port over hele flåten (API-et avviser og nevner innehaveren). Å kable mot en port som er medlem av en LAGG er lovlig — det er bond-tilfellet: den fremtidige avledningen gjengir det som LACP.',
    cablingInterface: 'Grensesnitt',
    cablingNotCabled: '— ikke tilkoblet —',
    cablingNoInterfaces: 'Ingen nettverksgrensesnitt observert',
    disksTitle: 'Disker',
    disksSubtitle: 'Observerte blokk-enheter — én skanning per rekonsilieringspass; merk her diskene som kan brukes som Ceph-OSD (N.15: kvalifiseringen er eksplisitt)',
    colDataDisk: 'Datadisk',
    dataDisksHint: 'Å krysse av en enhet erklærer den brukbar som OSD; serienummeret er identitetspinnen dens — kopiert fra hardwaren når disken rapporterer det, preget (tvirt-…) ellers. Ceph-registreringsdialogen tilbyr bare deklarerte disker.',
    diskDeclaredSerial: 'deklarert',
    diskNotObserved: 'deklarert men ikke observert — koble devicen til igjen eller fjern avkrysningen',
    noDisks: 'Ingen blokk-enhet observert ennå',
    colSerial: 'Serienummer',
    colModel: 'Modell',
    colSize: 'Størrelse (GiB)',
    colDiskType: 'Type',
    colInUse: 'I bruk',
    colObservedAt: 'Observert',
    diskInUse: 'i bruk',
    diskFree: 'ledig',
    diskMounted: 'montert',
    diskPartitions: 'partisjoner',
    passthroughTitle: 'Passthrough-enheter',
    passthroughSubtitle: 'Observerte GPU-er og USB-enheter — merk her hva TVirt kan sende videre til VM-ene; markeringen registrerer enhetens identitet (runde U1+G1)',
    passthroughHint: 'Markeringen registrerer enheten (en stabil id — targetet for tagger og klassekrav). En markert GPU får HELE IOMMU-gruppen bundet til vfio-pci i blokk — den forlater hosten umiddelbart; avmarkeringen kobler den native driveren til igjen. For USB finnes begge de ratifiserte modellene: per enhet (vendor+produkt, uansett hvor den er plugget) og per fysisk port (VM-en får hva enn som står i den). USB binder ikke ved markeringen — attach skjer i VM-ens runtime.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Brukbar av TVirt',
    colGpu: 'GPU',
    colPciAddress: 'PCI-adresse',
    colDriver: 'Driver',
    colVerdict: 'Dom',
    gpuEligible: 'Kvalifisert',
    gpuIneligible: 'Ikke kvalifisert',
    gpuReason: {
      'no-iommu': 'IOMMU er ikke aktiv på hosten',
      'group-spans-slots': 'IOMMU-gruppe ikke isolert: den strekker seg over andre slots',
      'multiple-display': 'IOMMU-gruppe ikke isolert: mer enn én videofunksjon',
      'foreign-function': 'IOMMU-gruppe ikke isolert: den inneholder en fremmed funksjon'
    },
    vfioNotReady: 'IOMMU er ikke aktiv på denne hosten: ingen GPU er kvalifisert før host-plattformen aktiverer den (OEM-ISO) — TVirt rører aldri kernel args i runtime.',
    vfioMissingKernelArg: 'IOMMU er ikke aktiv på denne hosten: firmwaren rapporterer VT-d/AMD-Vi (ACPI-tabell DMAR/IVRS til stede) men kernel arg-en mangler — legg til intel_iommu=on (Intel) eller fjern amd_iommu=off (AMD) fra kjernens command line og start på nytt. TVirt rører aldri kernel args i runtime.',
    vfioFirmwareDisabled: 'IOMMU er ikke aktiv på denne hosten: VT-d/AMD-Vi er deaktivert i firmwaren (ingen ACPI-tabell DMAR/IVRS), eller CPU-en støtter det ikke — aktiver det i firmware-oppsettet, ingen kernel arg kan slå det på. TVirt rører aldri hosten i runtime.',
    gpuBindError: 'vfio-pci-bind feilet på {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Brannmur på ikke-forvaltede bridges',
    firewallBridgesSubtitle: 'De håndbygde bridgene på denne noden hvis setup samtykker til TVirt-rendrede brannmur-chains på de tilkoblede guest-NIC-ene',
    firewallBridgesHint: 'TVirt rører aldri den fremmede bridgen — chainen forankres på tap/veth, som alltid er TVirts egen. Listen er en samtykkeport: default-deny og anti-spoof kan knekke det et manuelt setup forventer, så en NIC med brannmur på en ikke-forvaltet bridge som IKKE står her, avvises med en talende feil.',
    firewallBridgesEmpty: 'Ingen ikke-forvaltet bridge samtykker til TVirt-rendrede brannmur-chains på denne noden.',
    firewallBridgeAdd: 'Legg til bridge',
    firewallBridgeInvalid: 'Ikke et Linux-grensesnittnavn (1-15 tegn, uten skråstrek eller mellomrom)',
    firewallBridgeDuplicate: 'Navnet står allerede i listen',
    colMarkDevice: 'Per enhet',
    colMarkPort: 'Per port',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'foreldreløs — registrert men ikke lenger oppdaget: koble den til igjen eller avmerk den',
    noGpus: 'Ingen GPU observert ennå',
    noUsb: 'Ingen USB-enhet observert ennå',
    networkGeneration: 'Nettverksgenerasjon',
    applied: 'Anvendt',
    converged: 'på linje',
    behind: 'bak — {m} / {n}',
    notConfigured: 'ikke konfigurert',
    rollbackBody: 'Anvendelsen av generasjon {gen} feilet: {error}',
    rolledBackChip: 'rollback utført',
    nicsTitle: 'NIC-er',
    nicsSubtitle:
      'Registeret over forvaltede NIC-er — registreringen ER forvaltningserklæringen: en registrert NIC uten konfigurasjon røres ikke (clear-if erklærer den eksplisitt ren), en uregistrert enhet røres aldri',
    addNic: 'Registrer NIC',
    addNicTitle: 'Registrer NIC (add-nic)',
    delNic: 'Avslutt forvaltning',
    delNicTitle: 'Avslutt forvaltning (del-nic)',
    delNicConfirm:
      'Forvaltningen av {name} avsluttes: registeroppføringen og konfigurasjonen dens slettes og TVirt-profilen fjernes — enheten forblir slik Linux har den.',
    nicName: 'Enhetsnavn',
    nicMac: 'Permanent MAC-adresse',
    nicMacHint: 'den permanente hardware-MAC-en — den stabile identiteten fastsatt av TVirt Server Installer',
    colObserved: 'Observert',
    nicObserved: 'observert',
    nicNotObserved: 'ikke observert',
    nicMacMismatch: 'Avvikende MAC — observert {mac}',
    noNics: 'Ingen NIC registrert — registrer en enhet for å begynne å forvalte den',
    noManagedDevices: 'Ingen forvaltet enhet — registrer en NIC først, alt bygges på registeret',
    inventoryTitle: 'Observerte enheter',
    inventorySubtitle: 'Oppdatert ved hvert rekonsilieringspass av nodens worker — valideringen sjekker enhetsnavnene mot dette inventaret',
    colDevice: 'Enhet',
    colType: 'Type',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Hastighet',
    colTopology: 'Topologi',
    colMtu: 'MTU',
    colAddresses: 'Adresser',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP aggregerer ikke',
    noInventory: 'Ingen enhet rapportert så langt',
    interfacesTitle: 'Grensesnitt',
    interfacesSubtitle:
      'L3-konfigurasjon for de registrerte NIC-ene og de deklarerte logiske enhetene — set-if erstatter hele blokken, edit-if justerer egenskapene, clear-if tømmer den (eksplisitt rensing)',
    colConfig: 'Ønsket konfigurasjon',
    clean: 'ren',
    setIf: 'Rediger adressering',
    setIfTitle: 'Rediger adressering (set-if)',
    editIf: 'Rediger egenskaper',
    editIfTitle: 'Rediger egenskaper (edit-if)',
    clearIf: 'Tøm konfigurasjonen',
    clearIfTitle: 'Tøm konfigurasjonen (clear-if)',
    clearIfConfirm: 'Grensesnittets konfigurasjon tømmes. Et rent grensesnitt er forutsetningen for å underlegge det som medlem av bond/bridge eller parent for VLAN.',
    ip4Mode: 'IPv4-modus',
    ip6Mode: 'IPv6-modus',
    modeUnconfigured: 'Ikke konfigurert',
    modeStatic: 'Statisk',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4-adresser',
    ip6Addresses: 'IPv6-adresser',
    addressesHint: 'CIDR, kommaseparert',
    gw4: 'IPv4-gateway',
    gw6: 'IPv6-gateway',
    dns: 'DNS-servere',
    dnsHint: 'kommaseparert — tomt nullstiller DNS (set-if erstatter blokken)',
    routes4: 'Statiske IPv4-ruter',
    routes6: 'Statiske IPv6-ruter',
    routeTo: 'Destinasjon (CIDR)',
    routeVia: 'Via',
    addRoute: 'Legg til rute',
    routesChip: 'ruter',
    mtu: 'MTU',
    mtuHint: 'tomt = driverens default',
    vlansTitle: 'VLAN-er',
    addVlan: 'Legg til VLAN',
    addVlanTitle: 'Legg til VLAN (add-vlan)',
    delVlanTitle: 'Slett VLAN (del-vlan)',
    vlanParent: 'Parent-grensesnitt',
    vlanId: 'VLAN-ID',
    vlanPreview: 'Enhetsnavn',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Ingen VLAN deklarert',
    bondsTitle: 'Bonds',
    addBond: 'Legg til bond',
    addBondTitle: 'Legg til bond (add-bond)',
    editBondTitle: 'Rediger bond',
    editBond: 'Lagre bond',
    delBondTitle: 'Slett bond (del-bond)',
    bondName: 'Bond-navn',
    members: 'Medlemmer',
    membersHint: 'medlemmene må være rene grensesnitt (uten L3-konfigurasjon)',
    bondMode: 'Modus',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Primærmedlem',
    rate: 'LACP-rate',
    hash: 'Hash-policy for sending',
    colMembers: 'Medlemmer',
    colMode: 'Modus',
    noBonds: 'Ingen bond deklarert',
    bridgesTitle: 'Bridger',
    addBridge: 'Legg til bridge',
    addBridgeTitle: 'Legg til bridge (add-bridge)',
    editBridgeTitle: 'Rediger bridge',
    editBridge: 'Lagre bridge',
    delBridgeTitle: 'Slett bridge (del-bridge)',
    bridgeName: 'Bridge-navn',
    stp: 'STP',
    stpOn: 'STP aktiv',
    stpOff: 'STP av',
    colStp: 'STP',
    noBridges: 'Ingen bridge deklarert',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Sett hostname',
    setHostnameTitle: 'Sett hostname (set-hostname)',
    hostnameHint: 'Bare OS-identitet — nodens navn i klusteret røres ikke',
    notSet: 'ikke satt',
    staticHostsTitle: 'Statiske host-oppføringer',
    addStaticHost: 'Legg til oppføring',
    addStaticHostTitle: 'Legg til statisk host-oppføring',
    delStaticHostTitle: 'Slett statisk host-oppføring',
    hostIp: 'IP-adresse',
    hostNames: 'Navn',
    hostNamesHint: 'komma- eller mellomromsseparert',
    colIp: 'IP',
    colNames: 'Navn',
    noStaticHosts: 'Ingen statisk host-oppføring',
    delConfirm: 'Fjerning av {name} fra ønsket-dokumentet — nodens worker konvergerer med et NetworkManager-checkpoint og automatisk rollback.',
    remove: 'Fjern',
    opError: 'Nettverksoperasjonen ble avvist'
  }
}
